import maIsohService from "../maIsohService/maIsohService";
import Raven from 'raven-js';

export default angular.module('userServiceModule', [
	maIsohService
]).service('userService', function(maIsoh, $log) {
	/**
	 * Default values
	 * @type {{workplace: {}, homeplace: {}, agreement: {}}}
	 */
	this.userSettings = {workplace: {}, homeplace: {}, agreement: {}, prejimajiciOsoba: ""};
	
	/**
	 * Default values
	 * @type {{apiUrl: string, apiWSDLUrl: string, user: {login: string, password: string}}}
	 */
	this.appSettings = {
		apiUrl: 'https://autovraky.mzp.cz/autovrak/service/v7',
		apiWSDLUrl: 'https://autovraky.mzp.cz/autovrak/service/wsdl/v7',
		// apiUrl: 'https://autovraky-test.mzp.cz/autovrak/service/v7',
		// apiWSDLUrl: 'https://autovraky-test.mzp.cz/autovrak/service/wsdl/v7',
		user: {
			login: "",
			password: "",
		}
	};
	
	/**
	 * Invoice number
	 * @type {number}
	 */
	this.pcp = 0;
	
	/**
	 * Backup directory
	 * @type {string}
	 */
	this.backupDir = undefined;
	
	/**
	 * User object loaded from MA ISOH
	 * @type {{}}
	 */
	this.isohUser = {};
	
	/**
	 * Set default storage and set values
	 */
	/*let db = {
		userSettings: this.userSettings,
		appSettings: this.appSettings,
		pcp: this.pcp,
		backupDir: this.backupDir,
		isohUser: this.isohUser
	};*/
	
	let db = JSON.parse(localStorage.getItem('userSettings'));
	
	if (db == null) {
		db = {
			userSettings: this.userSettings,
			appSettings: this.appSettings,
			pcp: this.pcp,
			backupDir: this.backupDir,
			isohUser: this.isohUser
		};
	} else {
		Raven.setUserContext({
			login: db.appSettings.user.login,
			place: {ic: db.userSettings.workplace.ic, name: db.userSettings.workplace.nazev}
		});
	}
	
	this.userSettings = db.userSettings;
	this.appSettings = db.appSettings;
	this.pcp = db.pcp;
	this.backupDir = db.backupDir;
	this.isohUser = db.isohUser;
	
	
	maIsoh.setUser(angular.copy(this.appSettings.user));
	maIsoh.setAPIUrl(this.appSettings.apiUrl, this.appSettings.apiWSDLUrl);
	
	this.getUserSettings = () => {
		return angular.copy(this.userSettings);
	};
	
	this.getAppSettings = () => {
		return angular.copy(this.appSettings);
	};
	
	this.getPcp = () => {
		return angular.copy(this.pcp);
	};
	
	this.setPcp = (pcp) => {
		this.pcp = parseInt(pcp);
		db.pcp = this.pcp;
		localStorage.setItem('userSettings', JSON.stringify(db));
	};
	
	this.getIsohUser = () => {
		return angular.copy(this.isohUser);
	};
	
	this.setIsohUser = (user) => {
		this.isohUser = user;
		
		db.isohUser = this.isohUser;
		localStorage.setItem('userSettings', JSON.stringify(db));
	};
	
	this.setBackupDir = (dir) => {
		this.backupDir = dir;
	};
	
	this.getBackupDir = () => {
		return this.backupDir;
	};
	
	this.incrementPcp = () => {
		this.setPcp(this.getPcp() + 1);
	};
	
	/**
	 * Returns current user
	 * @returns {{login: '', password: ''}}
	 */
	this.getUser = () => {
		return angular.copy(this.appSettings.user);
	};
	
	this.setUserSettings = (settings) => {
		this.userSettings = angular.copy(settings);
		db.userSettings = this.userSettings;
		localStorage.setItem('userSettings', JSON.stringify(db));
		$log.debug('Nastavuju user settings', arguments);
		
		Raven.setUserContext({
			login: this.appSettings.user.login,
			place: {ic: this.userSettings.workplace.ic, name: this.userSettings.workplace.nazev}
		});
	};
	
	this.setAppSettings = (settings) => {
		this.appSettings = angular.copy(settings);
		maIsoh.setAPIUrl(this.appSettings.apiUrl, this.appSettings.apiWSDLUrl);
		
		db.appSettings = this.appSettings;
		localStorage.setItem('userSettings', JSON.stringify(db));
		this.setUserPassword(this.appSettings.user.password);
		$log.debug('Nastavuju app settings', this.appSettings.apiUrl, this.appSettings.apiWSDLUrl);
		
		Raven.setUserContext({
			login: this.appSettings.user.login,
			place: {ic: this.userSettings.workplace.ic, name: this.userSettings.workplace.nazev}
		});
	};
	
	this.setUserPassword = (password) => {
		let pass = angular.copy(password);
		db.appSettings.user.password = this.appSettings.user.password;
		localStorage.setItem('userSettings', JSON.stringify(db));
		maIsoh.setUser({login: this.appSettings.user.login, password: password});
		$log.debug('Menim heslo');
	};
	
	this.setReceivingUser = (user) => {
		this.userSettings.receivingUser = user;
		this.setUserSettings(this.userSettings);
	};
	
	/**
	 * Should we display intro wizard?
	 * @returns {(function())|*|boolean}
	 */
	this.displayIntro = () => {
		return !this.appSettings.introWizardDone;
	};
	
	/**
	 * Mark intro wizard as done
	 */
	this.introWizardDone = () => {
		this.appSettings.introWizardDone = true;
		this.setAppSettings(this.appSettings);
	};
	
	this.purgeSettings = () => {
		db.setState({});
	};
}).name;



// WEBPACK FOOTER //
// build/services/userService/userService.js